// extracted by mini-css-extract-plugin
export var backgroundImageCustom = "showcaseHeader-module--backgroundImageCustom--c7aa8";
export var caption = "showcaseHeader-module--caption--7b0b9";
export var headerText = "showcaseHeader-module--headerText--ff27c";
export var lightOnDarkDesktop = "showcaseHeader-module--lightOnDarkDesktop--d2482";
export var showcaseHeader = "showcaseHeader-module--showcaseHeader--68045";
export var showcaseImages = "showcaseHeader-module--showcaseImages--c0424";